import { Modal } from "react-bootstrap";
import useTranslator from "../hooks/useTranslator";

const SwitchUserConfirmationModal = ({
  onClose,
  type,
  email,
  handleChangeUser,
}) => {
  const { _t } = useTranslator();
  const oppoType = type === "tenant" ? "landlord" : "tenant";
  return (
    <div>
      <Modal
        show={true}
        centered
        className="tenant-confirmation-modal wrapper-modal"
      >
        <Modal.Header></Modal.Header>
        <Modal.Body>
          <h1 className="">
            {_t(`${oppoType}AlreadyExistDoYouWantToContinueAs${type}`)}
          </h1>
          <p>
            {_t("thisEmail")} <strong>{email}</strong>{" "}
            {_t(`alreadyExistAsA${oppoType}`)}
          </p>
          <div className="group-btn">
            <button className="" type="button" onClick={onClose}>
              {_t(`continueAs${type}`)}
            </button>
            <button
              className="continue-btn"
              type="button"
              onClick={handleChangeUser}
            >
              {_t(`continueAs${oppoType}`)}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SwitchUserConfirmationModal;
